import { render } from "./CompareMode.vue?vue&type=template&id=35f77875&scoped=true"
import script from "./CompareMode.vue?vue&type=script&lang=js"
export * from "./CompareMode.vue?vue&type=script&lang=js"

import "./CompareMode.vue?vue&type=style&index=0&id=35f77875&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f77875"]])

export default __exports__